export default "__VITE_ASSET__CWcfhIxS__"